import { Component } from '@angular/core'
import { FieldType } from '@ngx-formly/core'

@Component({
  selector: 'basin-formly-datepicker',
  templateUrl: './formly-datepicker.component.html',
  styleUrls: [],
})
export class FormlyDatepickerComponent extends FieldType {}
